import { Route } from '../../shared/models/route';
import { Dashboard } from '../views/dashboard';
import { Layout } from '../../shared/models/layout';
import { Feature } from '../../shared/models/features';
import reportIcon from '../../reports/assets/images/menu-icons/icon_reports.svg';

export const dashboardRoutes: Route = {
  path: '/dashboard',
  nameTranslationKey: `${Feature.DASHBOARD}:navigation.dashboard`,
  icon: reportIcon,
  view: Dashboard,
  displayInSideNavigation: true,
  hideIfEmpty: true,
  meta: {
    layout: Layout.SIDE_NAVIGATION,
    requiredPermission: ['DASHBOARD', 'READ'],
  },
};
